var map = {
	"./alert.png": "c90d",
	"./bank_logo.png": "9129",
	"./bitcoin_logo.png": "5598",
	"./bxs_wallet_icon.png": "47ab",
	"./cc_icon.png": "b840",
	"./creditDebitCard.png": "3963",
	"./credit_card_icon.png": "9de2",
	"./credit_img.jpg": "830e",
	"./credit_logo.png": "835c",
	"./deposit_bitcoin.png": "b604",
	"./fx-ir.png": "b461",
	"./inavailable_channel.png": "89ba",
	"./interac.png": "93ca",
	"./lbt_icon.png": "4bf3",
	"./master.png": "0606",
	"./master_card.png": "b5ad",
	"./neteller_logo.png": "10e0",
	"./select_PerfectMoney.png": "56fa",
	"./select_bank.png": "f5de",
	"./select_bank_bk.png": "2e6a",
	"./select_bitcoin.png": "4b02",
	"./select_fasapay.png": "0b7f",
	"./select_nigeria.png": "c88e",
	"./select_skill.png": "682e",
	"./select_thailand.png": "04a4",
	"./select_unionpay.png": "cdec",
	"./select_upi.png": "17dd",
	"./select_usdt.png": "cc36",
	"./select_vietna.png": "afa6",
	"./skill_logo.png": "c9ea",
	"./unionpay_logo.png": "003f",
	"./visa.png": "cd88",
	"./visa_logo.png": "3272"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13dd";